import React from 'react';
import { Icon } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './CertsListSidePanelBodyCommon.css';

const COLOR = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
};

function Timeline({ color, kind, isTailVisible }) {
  const timelineIconClasses = classnames(
    'Timeline-icon',
    color && `Timeline-color--${COLOR[color]}`
  );
  const timelineTailClasses = classnames('Timeline-tail');

  return (
    <div className='Timeline'>
      <div className={timelineIconClasses}>
        <Icon size='small' kind={kind} color='neutral-000' />
      </div>
      {isTailVisible && <div className={timelineTailClasses} />}
    </div>
  );
}

Timeline.propTypes = {
  color: PropTypes.oneOf(Object.keys(COLOR)),
  kind: PropTypes.string,
  isTailVisible: PropTypes.bool,
};

Timeline.defaultProps = {
  color: 'info',
  kind: '',
  isTailVisible: true,
};

export default Timeline;
